<template>
    <div>
        <div
            :class="{ background: true, expanded: isVisible }"
            @click="handleBackgroundClick"
        ></div>
        <el-aside :class="{ expanded: isVisible, 'sidebar-container': true }">
            <div class="contents-wrapper">
                <div>
                    <div class="logo-container">
                        <img class="logo-img" src="/static/vrs-white.svg" />
                        <div class="seperator" />
                    </div>
                    <div class="user-avatar">
                        <div class="avatar-wrapper">
                            <img class="avatar" src="/static/user.svg" width="36" height="36" />
                        </div>
                        <div class="my-5px user-name">{{ $t('Anonymous User') }}</div>
                    </div>
                </div>
                <div :class="{ expanded: isVisible }">
                    <div class="profile-button-wrapper">
                        <div class="button-wrapper">
                            <el-dropdown trigger="click" class="user-info cursor-pointer">
                                <el-button class="text-white" type="text" size="mini">
                                    <span> {{ langLabel }} </span>
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        v-for="item in $store.getters.getLangs"
                                        :key="item.languageCode"
                                        @click.native="languageCode = item.languageCode"
                                    >
                                        <span> {{ item.label }} </span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="seperator"></div>
                        <div class="copyright">{{ $t('Created by Virtual i Technologies') }}</div>
                    </div>
                </div>
            </div>
        </el-aside>
    </div>
</template>

<script>
export default {
    name: 'sidenav',
    props: {
        isVisible: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            languageCode: window.localStorage.language_code,
        };
    },
    computed: {
        langLabel() {
            return this.$store.getters.getLangs.filter((x) => x.languageCode === this.languageCode)
                .length > 0
                ? this.$store.getters.getLangs.filter(
                      (x) => x.languageCode === this.languageCode
                  )[0].label
                : '';
        },
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.$refs.nav.activeIndex = this.$refs.nav.defaultActive;

                if (this.$client.width <= 900 && this.isVisible) {
                    this.$emit('menuClick');
                }
            });
        },
        languageCode(value) {
            window.localStorage.language_code = value;
            window.location.reload();
        },
    },
    methods: {
        handleBackgroundClick() {
            this.$emit('menuClick');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/responsive.scss';

.background {
    position: fixed;
    left: -100%;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
    opacity: 0;
    background: rgba(0, 0, 0, 0.3);
    transition: opacity;

    &.expanded {
        left: 0;
        opacity: 1;
    }
}
aside.sidebar-container {
    height: 100%;
    overflow: hidden !important;
    width: 0 !important;
    left: -250px;
    background: var(--main-dark);
    transition: 0.5s;
    position: fixed;
    z-index: 15;
    &.expanded {
        left: 0;
        width: 250px !important;

        @include sm {
            width: 320px !important;
        }
    }
    .logo-container {
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .logo-img {
            width: 150px;
            padding: 30px 0;
        }
    }

    .profile-button-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--main-contrast);
        font-size: 16px;
        position: static;
        box-shadow: 0 1px 10px 7px var(--main-darker);
        .button-wrapper {
            margin-bottom: 10px;
            margin-top: 10px;
            .el-button--text {
                color: var(--main-contrast);
            }
        }
    }
    .seperator {
        width: 80%;
        height: 1px;
        background-color: var(--main-transparent);
    }
    .copyright {
        text-align: center;
        padding: 10px 0;
        font-size: 13px;
        color: var(--main-watermark);
    }
    .user-avatar {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 30px;
        .user-name {
            font-size: 18px;
            color: var(--main-contrast);
            cursor: pointer;
        }
        .avatar-wrapper {
            width: 100px;
            height: 100px;
            border-radius: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: var(--main-transparent);
            img.avatar {
                object-fit: cover;
                width: 65px;
                height: 65px;
                border-radius: 50%;
            }
        }
    }

    .profile-btn.text-primary {
        color: #008dd2 !important;
    }

    .contents-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        z-index: 15;
        height: 100%;
    }
}

@media (min-width: 768px) {
    aside.sidebar-container {
        position: relative !important;
        z-index: auto !important;
    }

    .background {
        display: none !important;
    }
}
</style>
